<template>
  <div class="u-followBox">
    <div class="followBox-wrap" v-if="toShow">
      <img src="../../assets/follow.png" class="follow_img">
    </div>
  </div>
</template>

<script>
export default {
  name: 'u-shareBox',
  data () {
    return {
      toShow: false
    }
  },
  props: {},
  methods: {
    show () {
      this.toShow = true
    },
    noShow () {
      this.toShow = false
    }
  }
}
</script>

<style lang="scss" scoped>
.u-followBox{
}
.followBox-wrap{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 3;
  .follow_img{
    position: absolute;
    width:612px;
    height: auto;
    right: 50%;
    bottom: 50%;
    transform: translate(50%,50%);
  }
}
</style>
